import { AuthService, IAuthService } from "./auth";
import {
    BackendService,
    IBackendService
} from "./backend";
import { CacheService, ICacheService } from "./cache";

export interface IServices {
    auth: IAuthService;
    backend: IBackendService;
    cache: ICacheService;
}

export function initServices(): IServices {
    const backend = new BackendService();
    const auth = new AuthService(backend);
    const cache = new CacheService(backend);
    return { auth, backend, cache };
}
